<template>
    <div>
        <div>
            <v-container fluid>

                <div class="d-flex align-center py-3">
                    <div>
                        <div class="display-1">Booking Builder</div>
                    </div>
                    <v-spacer></v-spacer>
                </div>
                <v-tabs
                        v-model="tab"
                        vertical
                >
                    <v-tab
                            href="#customer"
                    >
                        <v-icon left :color="validColor(customerValid)">
                            mdi-account
                        </v-icon>
                        Customer
                    </v-tab>
                    <v-tab
                            href="#booking"
                            :disabled="!customerValid"
                    >
                        <v-icon left :color="validColor(bookingValid)">
                            mdi-access-point
                        </v-icon>
                        Booking
                    </v-tab>

                    <v-tab
                            href="#review"
                            :disabled="!customerValid && !bookingValid"
                    >
                        <v-icon left>
                            mdi-teach
                        </v-icon>
                        Review
                    </v-tab>

                    <v-tabs-items :value="tab">

                        <v-tab-item value="customer">
                                <v-card flat>
                                    <v-card-text>
                                        <div class="display-1">Customer</div>
                                    <BookingBuilderCustomer :booking="booking" ref="customer"/>
                                    </v-card-text>
                                    <v-card-actions>
                                        <v-spacer/>
                                        <v-btn
                                                color="primary"
                                                @click="nextCustomer"
                                        >
                                            Continue
                                        </v-btn>

                                    </v-card-actions>
                                </v-card>
                        </v-tab-item>

                        <v-tab-item value="booking">
                            <v-card flat>
                                <v-row>
                                    <v-col cols="12">
                                        <BookingBuilderBookingDetails :booking="booking" ref="booking" />

                                    </v-col>
                                </v-row>


                                <v-card-actions>
                                    <v-spacer/>
                                    <v-btn
                                            color="primary"
                                            @click="nextBooking"
                                    >
                                        Continue
                                    </v-btn>

                                </v-card-actions>
                            </v-card>
                        </v-tab-item>


                        <v-tab-item value="review">
                                <v-card flat>

                                    <BookingBuilderReview :booking="booking"/>

                                    <v-card-actions>
                                        <v-spacer/>
                                        <v-btn
                                                color="primary"
                                                @click="createBooking"
                                                :disabled="(!customerValid && !bookingValid) || creating"
                                        >
                                            Create Booking
                                        </v-btn>
                                    </v-card-actions>

                                </v-card>

                        </v-tab-item>
                    </v-tabs-items>
                </v-tabs>

            </v-container>
        </div>
    </div>
</template>

<script>
    import BookingBuilderCustomer from "../components/Booking/Builder/BookingBuilderCustomer";
    import BookingBuilderBookingDetails from "../components/Booking/Builder/BookingBuilderBookingDetails";
    import BookingBuilderReview from "../components/Booking/Builder/BookingBuilderReview";
    import BOOKING_CREATE from "../graphql/Bookings/Create.gql";
    import moment from "moment";
    const TODAY = moment().set({hour: 0, minute: 0, second: 0, millisecond: 0});


    export default {
        components: {BookingBuilderCustomer, BookingBuilderBookingDetails, BookingBuilderReview},
        data() {
            return {
                tab: 'customer',
                creating: false,
                customerValid: null,
                bookingValid: null,
                booking: {
                    contactName: '',
                    contactCompany: '',
                    contactEmail: '',
                    contactAddress1: '',
                    contactAddress2: '',
                    contactAddress3: '',
                    contactTown: '',
                    contactCounty: '',
                    contactPostcode: '',
                    contactPhone: '',
                    customerPoRef: '',
                    invoiceName: '',
                    invoiceCompany: '',
                    invoiceEmail: '',
                    invoiceAddress1: '',
                    invoiceAddress2: '',
                    invoiceAddress3: '',
                    invoiceTown: '',
                    invoiceCounty: '',
                    invoicePostcode: '',
                    invoicePhone: '',
                    bookingDate: TODAY.format('YYYY-MM-DD'),
                    taxDate: null,
                    courseTitle: null,
                    vatRate: 0.2,
                    delegates: 0,
                    courseRate: 0,
                    days: 1,
                    dayRate: 0,
                    totalPrice: 0,
                    printedNotes: '',
                    nonPrintedNotes: '',
                    accountManager: '7',
                    trainingType: 'B2',
                    bookingType: 'A1',
                    craftId: '',
                },
                e1: 1,
            }
        },
        computed: {

        },
        methods: {
            nextCustomer() {
                if(this.$refs.customer.validate()){
                    this.customerValid = true
                    this.tab = 'booking'
                }else{
                    this.customerValid = false
                }
            },

            nextBooking() {
                this.$refs.booking.validate().then((valid) => {
                    this.bookingValid = valid
                    if(this.bookingValid){
                        this.tab = 'review'
                    }
                })

            },

            validColor(valid) {
                switch(valid) {
                    case true:
                        return 'green'
                    case false:
                        return 'red'
                    default:
                        return 'blue'
                }
            },

            createBooking() {
                this.creating = true
                let bookingData = JSON.parse(JSON.stringify(this.booking));
                console.log(bookingData)
                bookingData.accountManager = {connect: this.booking.accountManager}
                if(this.booking.customer) {
                    bookingData.customer = {connect: this.booking.customer}
                }else {
                    let newCustomer  =  {
                        company: this.booking.contactCompany ,
                        contactAddress1: this.booking.contactAddress1 ,
                        contactAddress2: this.booking.contactAddress2 ,
                        contactAddress3: this.booking.contactAddress3 ,
                        contactTown: this.booking.contactTown ,
                        contactCounty: this.booking.contactCounty ,
                        contactPostcode: this.booking.contactPostcode ,
                        contactName: this.booking.contactName ,
                        contactPhone: this.booking.contactPhone ,
                        contactEmail: this.booking.contactEmail ,
                        accountsName: this.booking.invoiceName ,
                        accountsPhone: this.booking.invoicePhone ,
                        accountsEmail: this.booking.invoiceEmail ,
                        accountsAddress1: this.booking.invoiceAddress1 ,
                        accountsAddress2: this.booking.invoiceAddress2 ,
                        accountsAddress3: this.booking.invoiceAddress3 ,
                        accountsTown: this.booking.invoiceTown ,
                        accountsCounty: this.booking.invoiceCounty ,
                        accountsPostcode: this.booking.invoicePostcode ,
                        paymentTermsDays: '14',
                    }
                    bookingData.customer = {create: newCustomer}

                }
                bookingData.statuses = {
                    create: [
                        {name: "DRAFT"}
                    ]
                }
                console.log(bookingData)
                this.$apollo.mutate({
                    mutation: BOOKING_CREATE,
                    variables: {input: bookingData},
                }).then((response) => {
                    this.$emit('complete')
                    this.creating = false
                    this.$emit('saved')
                    this.$store.dispatch('notification/addSuccess', 'Booking created successful')
                    this.$router.push({ name: 'booking-view', params: { id: response.data.createBooking.id } })
                }).catch((error) => {
                    this.creating = false
                    this.$store.dispatch('notification/handleGraphQlError', error)
                })
            }
        },
    }
</script>

<style scoped>

</style>